<div class="toasts">
  @for (message of data.messages; track $index) {
    <div class="toast">
      @if (message.icon) {
        <mat-icon [style.color]="message.color">{{ message.icon }}</mat-icon>
      }
      <span>{{ message.message }}</span>
    </div>
  }
</div>
